const CACHE_PREFIX = 'productData';
const CACHE_TIME_PREFIX = 'productDataTime';
// Синхронизировано с Cache-Control: max-age=300 на бэкенде (api/views.py) —
// чтобы цена/наличие не могли "зависнуть" на экране дольше, чем бэкенд
// сам считает приемлемым окном устаревания.
const CACHE_DURATION = 5 * 60 * 1000; // 5 минут в миллисекундах

const generateCacheKey = (category, subcategory) => {
  return `${CACHE_PREFIX}-${category}-${subcategory || ''}`;
};

const generateCacheTimeKey = (category, subcategory) => {
  return `${CACHE_TIME_PREFIX}-${category}-${subcategory || ''}`;
};

// localStorage может бросить исключение (приватные вкладки Safari, отключённое
// хранилище корпоративными политиками, забитая квота) — без try/catch это
// синхронно прервёт useEffect в компоненте, который вызвал getFromCache,
// и такой компонент (например, главная страница) уйдёт в ErrorBoundary
// вместо того, чтобы просто показать данные без кеша.
export const saveToCache = (category, subcategory, data) => {
  try {
    const cacheKey = generateCacheKey(category, subcategory);
    const cacheTimeKey = generateCacheTimeKey(category, subcategory);
    localStorage.setItem(cacheKey, JSON.stringify(data));
    localStorage.setItem(cacheTimeKey, Date.now().toString());
  } catch (error) {
    // Кеш — необязательная оптимизация, недоступность localStorage не должна
    // ломать страницу.
  }
};

export const getFromCache = (category, subcategory) => {
  try {
    const cacheKey = generateCacheKey(category, subcategory);
    const cacheTimeKey = generateCacheTimeKey(category, subcategory);
    const data = localStorage.getItem(cacheKey);
    const timestamp = localStorage.getItem(cacheTimeKey);

    if (data && timestamp) {
      const age = Date.now() - parseInt(timestamp, 10);
      if (age < CACHE_DURATION) {
        return JSON.parse(data);
      }
    }
  } catch (error) {
    // см. комментарий в saveToCache
  }

  return null;
};
